<template>
    <b-row>
        <b-col class="pmis-header d-none d-sm-none d-md-none d-lg-block"></b-col>
        <b-col class="pmis-header-repeat"></b-col>
    </b-row>
</template>

<script>
    export default {
        name: "PmisHeader"
    }
</script>

<style lang="scss" scoped>
    .pmis-header {
        background-image: url('../../assets/pic/iot-header-left.png');
        background-repeat: no-repeat;
        background-size: auto;
        height: 300px;
        background-position: bottom left;
    }
    .pmis-header-repeat {
        background-image: url('../../assets/pic/iot-header.png');
        background-repeat: repeat-x;
        background-size: 400px 153px;
        background-position: bottom;
        height: 300px;
        z-index: -1;
    }
</style>
